<template>
  <v-card class="modif-paie-v-card" elevation="0">
    <v-row>
      <v-col
          cols="12"
          md="5"
          style=" padding: 38px"
          class="d-flex flex-column"
      >
        <div class="modif-paie-header">
          <span class="modif-paie-stars">★★★ </span>
          <span class="modif-paie-title">Modifiez en illimité sans frais avec l'offre Forte</span>
        </div>
        <div class="modif-paie-subtitle">
          Annulez ou modifiez une paie autant que vous voulez, sans frais.
        </div>

        <div
            class="modif-paie-description"
            style="flex-grow: 1; margin-bottom: 20px; display: flex; flex-direction: column; gap: 30px;"
        >
          <span class="modif-paie-feature-list-header">Forte c'est aussi :</span>
          <ul class="modif-paie-feature-list" style="list-style: none; padding-left: 0;">
            <li>
              <i class="fa-solid fa-gears"></i>
              Génération des DSN à néant
            </li>
            <li>
              <i class="fa-solid fa-headset"></i>
              Un support technique réactif
            </li>
            <li>
              <i class="fa-solid fa-vault"></i>
              Un espace document employeur et salarié sécurisé
            </li>
            <li>
              <i class="fa-solid fa-chart-line"></i>
              Des analytiques par productions
            </li>
          </ul>
        </div>

        <div class="d-flex flex-column align-center" style="gap: 10px">
          <loader-button class="ms-2"
                         :label="btnSansLabel"
                         :full-width="true"
                         @callback="closeDialog"
          >
          </loader-button>
          <loader-button
              class="ms-2"
              :label="btnAvecLabel"
              :outlined="true"
              :full-width="true"
              @callback="closeDialog"
          >
          </loader-button>
        </div>
      </v-col>

      <v-col
          class="modif-paie-subscription-right-panel"
          style="position: relative;"
      >
        <v-icon
            @click="closeDialog"
            class="header-text"
            style="position: absolute; top: 12px; right: 12px; cursor: pointer;"
        >
          fas fa-xmark
        </v-icon>

        <div
            class="d-flex justify-center align-center"
            style="height: 100%; min-height: 200px;"
        >
          <img
              src="@/assets/svg/doc_preview.png"
              alt="Logo"
              class="modif-paie-subscription-logo"
          />
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>


<script lang="ts">
import {defineComponent} from "vue";
import LoaderButton from "@/framework/base/components/LoaderButton.vue";
import SectionHeader from "@/framework/base/components/SectionHeader.vue";
import {GenSection, RessourceGenSection} from "@/generated/ressources/generatedRessources.ts";


export default defineComponent({
  components: {SectionHeader, LoaderButton},

  props: {},
  data() {
    return {}
  },

  computed: {
    ressourceHeader() {
      const headerResource = RessourceGenSection(GenSection.SUBSCRIPTION);
      headerResource.label = 'Abonnement pour ';
      return headerResource;
    },
    btnSansLabel() {
      return 'Modifier sans frais';
    },
    btnAvecLabel() {
      return 'Modifier avec frais';
    }
  },

  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    }
  }
})
</script>

<style>
.modif-paie-v-card {
  padding: 0px !important;
  margin: 0px !important;
}

.modif-paie-header {
  font-size: 27px;
  font-weight: 500;
  padding-bottom: 16px;
}

.modif-paie-subtitle {
  color: #135253;
  font-size: 20px;
  font-weight: 400;
  padding-bottom: 36px;
}

.modif-paie-feature-list-header {
  font-size: 19px;
  font-weight: 500;
  margin-bottom: 20px;
}

.modif-paie-feature-list li {
  margin-bottom: 20px;
}

.modif-paie-feature-list li i {
  margin-right: 10px;
  color: #135253;
}

.modif-paie-subscription-right-panel {
  background-color: #F7F8F8;
  justify-content: center;
}

.modif-paie-subscription-logo {
  width: 457px;
  height: 461px;
}
</style>